import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "97",
  height: "111",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M75.285 72.643C75.285 51.853 58.432 35 37.642 35S0 51.854 0 72.643s16.853 37.574 37.642 37.574l2.193.001h35.45z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#0A4D7F",
      d: "M71 72.53C71 54.013 56.002 39 37.5 39S4 54.012 4 72.53 18.998 106 37.5 106l1.952.001H71z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-width": "4",
      d: "M38.5 53C49.27 53 58 61.73 58 72.5V92H38.5C27.73 92 19 83.27 19 72.5S27.73 53 38.5 53ZM73.093 48.662c-.013-17.145-.03-32.834-.01-38.39H58.896v25.205a43 43 0 0 1 14.197 13.185Z"
    }, null, -1)
  ])))
}
export default { render: render }